import React from 'react';
import Iconography, {
  IconographySizes,
} from '@hid-galaxy-ui/galaxy-react/components/Iconography';

const RULE_ICON_MAP: Record<string, string> = {
  UPLOAD_RESTRICTIONS: 'file',
  FACE_REQUIRED: 'imagePortrait',
  SINGLE_FACE: 'imagePortrait',
  FACE_FULLY_VISIBLE: 'circleUser',
  FACE_COVERAGE: 'circleUser',
  FACE_TILT: 'circleUser',
  DISALLOW_OCCLUSION: 'ban',
  EYES_OPEN: 'eye',
  DISALLOW_SUNGLASSES: 'eyeSlash',
  BACKGROUND_COLOR: 'image',
  BRIGHTNESS: 'brightness',
  CONTRAST: 'plusMinus',
  BLUR: 'circleCamera',
  MIN_RESOLUTION: 'image',
};

export const getRuleIcon = (
  ruleName: string,
  options?: { className?: string },
): JSX.Element => {
  const icon = RULE_ICON_MAP[ruleName] || 'circleExclamation';
  return (
    <Iconography
      icon={icon}
      size={IconographySizes.Medium}
      className={options?.className}
    />
  );
};

export default getRuleIcon;
